import Select from 'react-select';
import CreateSelect from 'react-select/creatable';
import styled, { css } from 'styled-components/macro';

export const SelectStyled = styled(Select)<{
  $isFilterDropdown?: boolean;
  $hasError?: boolean;
  $isMultiSelect?: boolean;
  $dropdownMenuHeight?: string;
  $containerStyles?: string;
}>`
  /* 
  Firefox browser fix - SelectField dropdown broke if sentence is too long
  */
  display: grid;
  grid-template-columns: minmax(0, 1fr);

  ${({ $isFilterDropdown }) =>
    $isFilterDropdown &&
    css`
      @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
        width: 100%;
      }
    `}

  .true__control {
    height: 2.5rem;
    padding: ${({ theme }) => '0 0 0 ' + theme.spacing.zero_3};
    border-color: ${({ theme, $hasError }) =>
      $hasError ? theme.colors.negative_dark : theme.colors.black_20};
    box-shadow: none;

    background-color: ${({ theme, isDisabled }) =>
      isDisabled ? theme.colors.black_5 : theme.colors.white};

    ${({ $isMultiSelect, theme }) =>
      $isMultiSelect &&
      `.true__placeholder {
        color: ${theme.colors.black_100};
      }`}

    &--is-focused {
      border-color: ${({ $containerStyles, theme }) =>
        $containerStyles ? 'none' : theme.colors.primary};
    }
    :hover {
      border-color: ${({ theme }) => theme.colors.black_10};
    }
    ${({ $isFilterDropdown }) =>
      $isFilterDropdown &&
      css`
        @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
          width: 100%;
        }
      `}
  }

  .true__value-container {
    flex-wrap: nowrap;
    padding: 0;
  }

  .true__single-value {
    position: static;
    top: 0;

    max-width: 100%;
    margin: 0;

    color: ${({ theme, isDisabled }) =>
      isDisabled ? theme.colors.black_40 : theme.colors.black_100};
    text-overflow: initial;

    transform: translateY(0);
  }

  .true__control--menu-is-open {
    border: 1px solid;
    border-color: ${({ theme, $hasError }) =>
      $hasError ? theme.colors.negative_dark : theme.colors.black} !important;

    box-shadow: none;
  }

  ${({ $containerStyles }) =>
    $containerStyles &&
    `${$containerStyles}
  .true__control--menu-is-open {
  
    border: unset;

    box-shadow: none;
  }
  `}

  .true__indicator-separator {
    display: none;
  }

  .true__indicator {
    color: ${({ theme }) => theme.colors.black_40};
  }

  .true__menu {
    z-index: 100;

    color: ${({ theme }) => theme.colors.black_100};
  }

  .true__option {
    &--is-focused {
      background-color: ${({ theme }) => theme.colors.black_5} !important;
    }

    &--is-selected {
      background-color: ${({ theme }) => theme.colors.black_10} !important;
      color: ${({ theme }) => theme.colors.black_100} !important;
    }
  }

  .true__placeholder {
    position: static;
    top: 0;

    color: ${({ theme, isDisabled }) =>
      isDisabled ? theme.colors.black_40 : theme.colors.black_60};

    transform: translateY(0);

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .true__menu-list {
    ${({ $dropdownMenuHeight }) =>
      $dropdownMenuHeight &&
      css`
        max-height: ${$dropdownMenuHeight};
        overflow-y: auto;
      `}
  }
`;

export const CreateSelectStyled = styled(CreateSelect)<{
  $isFilterDropdown?: boolean;
  $hasError?: boolean;
  $isMultiSelect?: boolean;
  $dropdownMenuHeight?: string;
  $containerStyles?: string;
}>`
  /* 
  Firefox browser fix - SelectField dropdown broke if sentence is too long
  */
  display: grid;
  grid-template-columns: minmax(0, 1fr);

  ${({ $isFilterDropdown }) =>
    $isFilterDropdown &&
    css`
      @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
        width: 100%;
      }
    `}

  ${({ $containerStyles }) => $containerStyles && $containerStyles}

  .true__control {
    height: 2.5rem;
    padding: ${({ theme }) => '0 0 0 ' + theme.spacing.zero_3};
    border-color: ${({ theme, $hasError }) =>
      $hasError ? theme.colors.negative_dark : theme.colors.black_20};
    box-shadow: none;

    background-color: ${({ theme, isDisabled }) =>
      isDisabled ? theme.colors.black_5 : theme.colors.white};

    ${({ $isMultiSelect, theme }) =>
      $isMultiSelect &&
      `.true__placeholder {
        color: ${theme.colors.black_100};
      }`}

    &--is-focused {
      border-color: ${({ theme }) => theme.colors.primary};
    }
    :hover {
      border-color: ${({ theme }) => theme.colors.black_10};
    }
    ${({ $isFilterDropdown }) =>
      $isFilterDropdown &&
      css`
        @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
          width: 100%;
        }
      `}
  }

  .true__value-container {
    flex-wrap: nowrap;
    padding: 0;
  }

  .true__single-value {
    position: static;
    top: 0;

    max-width: 100%;
    margin: 0;

    color: ${({ theme, isDisabled }) =>
      isDisabled ? theme.colors.black_40 : theme.colors.black_100};
    text-overflow: initial;

    transform: translateY(0);
  }

  .true__control--menu-is-open {
    border: 1px solid;
    border-color: ${({ theme, $hasError }) =>
      $hasError ? theme.colors.negative_dark : theme.colors.black} !important;

    box-shadow: none;
  }

  .true__indicator-separator {
    display: none;
  }

  .true__indicator {
    color: ${({ theme }) => theme.colors.black_40};
  }

  .true__menu {
    z-index: 100;

    color: ${({ theme }) => theme.colors.black_100};
  }

  .true__option {
    &--is-focused {
      background-color: ${({ theme }) => theme.colors.black_5} !important;
    }

    &--is-selected {
      background-color: ${({ theme }) => theme.colors.black_10} !important;
      color: ${({ theme }) => theme.colors.black_100} !important;
    }
  }

  .true__placeholder {
    position: static;
    top: 0;

    color: ${({ theme, isDisabled }) =>
      isDisabled ? theme.colors.black_40 : theme.colors.black_60};

    transform: translateY(0);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .true__menu-list {
    ${({ $dropdownMenuHeight }) =>
      $dropdownMenuHeight &&
      css`
        max-height: ${$dropdownMenuHeight};
        overflow-y: auto;
      `}
  }
`;
